import $ from "jquery";
import "tinymce";
import "datatables.net";
import "datatables.net-rowreorder-dt";
import 'bootstrap-icons/font/bootstrap-icons.css';
import bootbox from 'bootbox';
import { showMessage } from "./main";
var dataTable;
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "material")
        return;
    initDataTable();
    initMaterialSaveOrder();
    initMaterialDelete();
});
function initDataTable() {
    dataTable = $('#tableMaterial').DataTable({
        rowReorder: {
            enable: true,
            selector: 'td:first-child'
        },
        ordering: true,
        columnDefs: [
            {
                target: 0,
                visible: false,
                searchable: false
            },
            {
                target: 1,
                visible: false
            },
            { 'orderable': false, 'targets': [1, 2, 3] }
        ],
        language: {
            info: 'Strana _PAGE_ z _PAGES_',
            infoEmpty: 'Žiadne údaje',
            infoFiltered: '(filtrované z _MAX_ celkových záznamov)',
            lengthMenu: 'Zobraziť _MENU_ záznamov na stránku',
            zeroRecords: 'Nič sa nenašlo',
            search: 'Hľadať:'
        }
    });
}
function initMaterialSaveOrder() {
    $("#btnSaveOrderMaterial").on('click', function () {
        var data = dataTable.rows({ order: 'applied' }).data();
        var ids = [];
        data.each(function (value, index) {
            ids.push(value[1]);
        });
        var formData = {
            ids: ids
        };
        var request = $.ajax({
            type: 'Post',
            url: '/Material/SaveOrder/',
            data: JSON.stringify(formData),
            contentType: 'application/json',
            beforeSend: function () {
                $('#spinnerContainer').removeClass('d-none');
            },
            complete: function () {
                $('#spinnerContainer').addClass('d-none');
            }
        });
        request.done(function (res) {
            if (res.error == true) {
                showMessage(res.message, "Chyba!");
            }
            else {
                showMessage(res.message);
            }
        });
        request.fail(function (jqXHR) {
            console.error(jqXHR);
        });
    });
}
function initMaterialDelete() {
    $("#tableMaterial tbody").off('click', '.delete');
    $('#tableMaterial tbody').on('click', '.delete', function () {
        var id = $(this).data("id");
        bootbox.confirm('Naozaj chcete zmazať headline?', function (result) {
            if (result == true) {
                deleteMaterial(id);
            }
        });
    });
}
function deleteMaterial(id) {
    var request = $.ajax({
        type: 'Post',
        url: '/Material/Delete/' + id,
        contentType: 'application/json',
        beforeSend: function () {
            $('#spinnerContainer').removeClass('d-none');
        },
        complete: function () {
            $('#spinnerContainer').addClass('d-none');
        }
    });
    request.done(function (res) {
        if (res.error == true) {
            showMessage(res.message);
        }
        else {
            var row = dataTable.row('#tr_' + id);
            row.remove().draw();
        }
    });
    request.fail(function (jqXHR) {
        console.error(jqXHR);
    });
}
//# sourceMappingURL=material.js.map